export const getHealthEndpoint = (): string => "/api/health";

//usermanagement
export const getUserManagementEndpoint = (): string => "/api/management/users";
export const addUserManagementEndpoint = (): string => "/api/management/user";
export const getUserManagementDetailsEndpoint = (uuid: string): string => `/api/management/user/${uuid}`;
export const UpdateUserManagementEndpoint = (uuid: string): string => `/api/management/user/${uuid}`;

export const getRolesEndpoint = (): string => "/api/management/roles";
export const getFeaturesEndpoint = (): string => "/api/management/features";
export const getFeaturesByRoleEndpoint = (roleId: number): string => `/api/management/roles/${roleId}`;

export const getUserManagementMandantEndpoint = (): string => "/api/management/mandanten";
export const searchMandantenEndpoint = (
    search: string,
    limit = 10,
    searchByUuid = false
): string =>
    `/api/management/search?searchByUuid=${searchByUuid}&limit=${limit}&searchTerm=${encodeURIComponent(search)}`;
// Locations
export const getUserManagementLocationsEndpoint = (): string => "/api/management/locations";
export const addUserManagementLocationEndpoint = (): string => "/api/management/location";
export const getUserManagementLocationEndpoint = (locationUuid: string) => `/api/management/location/${locationUuid}`
export const UpdateUserManagementLocationEndpoint = (locationUuid: string) => `/api/management/location/${locationUuid}`
export const DeleteUserManagementLocationEndpoint = (locationUuid: string) => `/api/management/location/${locationUuid}`


// Device Management
export const getDevicesManagementEndpoint = (): string => "/api/management/devices";
export const addDeviceManagementEndpoint = (): string => "/api/management/device";
export const getDeviceManagementDetailsEndpoint = (deviceUuid: string): string => `/api/management/device/${deviceUuid}`;
export const UpdateDeviceManagementEndpoint = (deviceUuid: string): string => `/api/management/device/${deviceUuid}`;
export const DeleteDeviceManagementEndpoint = (deviceUuid: string): string => `/api/management/device/${deviceUuid}`;
export const getManagementCompaniesEndpoint = (): string => "/api/management/companies";
export const getManagementDeviceTypesEndpoint = (): string => "/api/management/devicetypes";


// Billing
export const getTopicMetricsBillingEndpoint = (): string => "/api/billing/topic/metrics";

// Device Groups
export const getDeviceGroupsManagementEndpoint = (): string => "/api/management/groups";
export const getDeviceGroupManagementEndpoint = (groupUuid: string): string => `api/management/group/${groupUuid}`;
export const addDeviceGroupManagementEndpoint = (): string => "api/management/group/";
export const updateDeviceGroupManagementEndpoint = (groupUuid: string): string => `api/management/group/${groupUuid}`;
export const deleteDeviceGroupManagementEndpoint = (groupUuid: string): string => `api/management/group/${groupUuid}`;

// Devices
export const getDeviceOverviewEndpoint = (): string => "/api/device";

// Device
export const getDeviceEndpoint = (deviceId: string, deviceType: string): string =>
    `/api/device/${deviceType}/${deviceId}`;

export const getDeviceFeaturesEndpoint = (deviceType: string): string =>
    `/api/device/${deviceType}/features`;

export const getPrimarydataGeneralEndpoint = (
    deviceUuid: string,): string =>
    `/api/device/${deviceUuid}/primarydata/General`;


export const updatePrimaryDataGeneralDisplayNameEndpoint = (
    deviceUuid: string) =>
    `/api/device/${deviceUuid}/primarydata/General`;


export const getContactsEndpoint = (): string => "/api/management/contacts";
export const getContactEndpoint = (contactUuid: string): string => `api/management/contact/${contactUuid}`;
export const updateContactEndpoint = (contactUuid: string): string => `api/management/contact/${contactUuid}`;
export const addContactEndpoint = (): string => "/api/management/contact";
export const getContactsSettingsEndpoint = (): string => "/api/management/contacts/settings";
export const addCompanyEndpoint = (): string => "/api/company"
export const updateCompanyEndpoint = (companyUuid: string): string =>
    `/api/company/${companyUuid}`;

export const getBatteryEndpoint = (deviceId: string, deviceType: string): string =>
    `/api/device/${deviceType}/${deviceId}/Battery`;
export const getWallboxEndpoint = (deviceId: string, deviceType: string): string =>
    `/api/device/${deviceType}/${deviceId}/Wallbox`;
export const getInverterEndpoint = (deviceId: string, deviceType: string): string =>
    `/api/device/${deviceType}/${deviceId}/Inverter`;
export const getExternalConnectionsEndpoint = (deviceType: string, deviceId: string): string =>
    `/api/device/${deviceType}/${deviceId}/Connections`;
export const getAuxEndpoint = (deviceType: string, deviceId: string): string =>
    `/api/device/${deviceType}/${deviceId}/Aux`;
export const getAuxSummaryEndpoint = (deviceType: string, deviceUuid: string): string =>
    `/api/device/${deviceType}/${deviceUuid}/aux/summary`;

export const getSingleLineDiagramEndpoint = (deviceType: string, deviceId: string): string =>
    `/api/device/${deviceType}/${deviceId}/Sld`;
export const getControlDataEndpoint = (deviceType: string, deviceId: string): string =>
    `/api/device/${deviceType}/${deviceId}/Control`;

// Events
export const getEventsEndpoint = (): string => `/api/device/events`;

export const getEventCountEndpoint = (deviceId: string) =>
    `/api/device/${deviceId}/events/count`;

export const updateEventConfirmEndpoint = (deviceId: string,  eventId: string): string =>
    `/api/device/${deviceId}/event/${eventId}/acknowledge`;

export const updateEventIgnoreEndpoint = (deviceId: string,  eventId: string): string =>
    `/api/device/${deviceId}/event/${eventId}/ignore`;

// Overview
export const getOverviewEndpoint = (): string => "/api/overview";

// User
export const getUserEndpoint = (): string => "/api/user";
export const resetUserPasswordEndpoint = (): string => "/api/user/reset/password";
export const updateUserSettingsEndpoint = (userId: string) => `/api/user/${userId}/update/settings`;
export const createTestMailEndpoint = (userId: string) => `/api/user/${userId}/create/testmail`;
export const uploadAvatarEndpoint = (userId: string) => `/api/user/${userId}/upload/avatar`;

// Cases

export const getCasesEndpoint = (): string => "/api/case";
export const getCaseEndpoint = (caseId: number): string => `/api/case/${caseId}`;
export const getCategoriesEndpoint = (): string => "/api/category";
export const getComponentsEndpoint = (): string => "/api/component";

export const getNewCasesEndpoint = (): string => "/api/case/new";
export const getUpdateCasesEndpoint = (caseId: number): string => `/api/case/${caseId}/update`;
export const getClosedCasesEndpoint = (caseId: number): string => `/api/case/${caseId}/close`;

// Operation Reports
export const getOperationsEndpoint = (): string => "/api/report/operations";
export const getOperationEndpoint = (operationId: number): string => `/api/report/operation/${operationId}`;
export const getNewOperationsEndpoint = (): string => "/api/report/operation/new";
export const getUpdateOperationsEndpoint = (operationId: number): string =>
    `/api/report/operation/${operationId}/update`;

// Monthly Reports
export const getMonthReportEndpoint = (): string => "/api/report/monthly";
